// document.addEventListener('DOMContentLoaded', function() {
//   const contentContainer = document.querySelector(".rte.mt-4.more-content");
//   if (contentContainer) {
//       contentContainer.classList.remove("hidden");
//     const paragraphs = contentContainer.querySelectorAll("p");
//     if (paragraphs.length > 1) {
//       const additionalContent = document.createElement("div");
//       additionalContent.classList.add("additional-content");
//       additionalContent.classList.add("additional-content", "hidden");
      
//       for (let i = 1; i < paragraphs.length; i++) {
//         additionalContent.appendChild(paragraphs[i]);
//       }
//       contentContainer.appendChild(additionalContent);
//       const toggleButtonContent = document.createElement("div");
      
//       const toggleButton = document.createElement("button");
//       toggleButton.classList.add("toggle-button");
//       toggleButton.textContent = "Read More...";
//       toggleButton.style.display = "none";
//       contentContainer.appendChild(toggleButton);
//       toggleButton.addEventListener("click", function () {
//         if (
//           additionalContent.style.display === "none" ||
//           additionalContent.style.display === ""
//         ) {
//           additionalContent.style.display = "block";
//           toggleButton.textContent = "Read Less";
//         } else {
//           additionalContent.style.display = "none";
//           toggleButton.textContent = "Read More...";
//         }
//       });
//       const mediaQuery = window.matchMedia("(max-width: 768px)");
//       function handleMediaChange(e) {
//         if (e.matches) {
//           toggleButton.style.display = "inline-block";
//           additionalContent.classList.add("hidden");
//         } else {
//           toggleButton.style.display = "none";
//           additionalContent.classList.remove("hidden"); 
//         }
//       }
//       mediaQuery.addEventListener("change", handleMediaChange);
//       handleMediaChange(mediaQuery);
//     }
//   }
// });

function setupParagraphs() {
  const contentContainer = document.querySelector(".rte.mt-4.more-content");
  if (!contentContainer) return;

  // Remove existing toggle and additionalContent if present (clean-up before re-render)
  const oldToggle = contentContainer.querySelector(".toggle-button");
  if (oldToggle) oldToggle.remove();
  const oldAdditional = contentContainer.querySelector(".additional-content");
  if (oldAdditional) {
    // Move its children (paragraphs) back to container
    while (oldAdditional.firstChild) {
      contentContainer.insertBefore(oldAdditional.firstChild, oldAdditional);
    }
    oldAdditional.remove();
  }

  contentContainer.classList.remove("hidden");
  const paragraphs = Array.from(contentContainer.querySelectorAll("p"));
  const isMobile = window.innerWidth <= 1023;
  const visibleCount = isMobile ? 1 : 2;

  if (paragraphs.length > visibleCount) {
    const additionalContent = document.createElement("div");
    additionalContent.classList.add("additional-content");
    additionalContent.style.display = "none";
    // Move paragraphs into additionalContent after visibleCount
    for (let i = visibleCount; i < paragraphs.length; i++) {
      additionalContent.appendChild(paragraphs[i]);
    }

    const toggleButton = document.createElement("button");
    toggleButton.classList.add("toggle-button");
    toggleButton.textContent = "Read More...";
    toggleButton.style.display = "inline-block";
    toggleButton.style.marginTop = "1em";

    toggleButton.addEventListener("click", function () {
      const isHidden = additionalContent.style.display === "none" || additionalContent.style.display === "";
      additionalContent.style.display = isHidden ? "block" : "none";
      toggleButton.textContent = isHidden ? "Read Less" : "Read More...";
    });

    contentContainer.appendChild(additionalContent);
    contentContainer.appendChild(toggleButton);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setupParagraphs();
  // Re-run setupParagraphs when window size changes
  window.addEventListener('resize', setupParagraphs);
});

